import styled from "styled-components"

export const CanvasContainer = styled.div`
  width: 100%;
  height: calc(100vh - 18rem);
  min-height: 55rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.greyLighter};
  position: relative;

  @keyframes dropTargetPulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }

  .react-flow__edge.drop-target .react-flow__edge-path {
    stroke: #10b981;
    stroke-width: 3;
    stroke-dasharray: 8 4;
    animation: dropTargetPulse 1s ease-in-out infinite;
  }

  &.animating .react-flow__node {
    transition: transform 0.35s cubic-bezier(0.25, 0.1, 0.25, 1);
  }
`
